module.exports = __webpack_public_path__ + "assets/psychol.ru.a4021f40b2aca8dacb1d1ad3328367b95d6524ffc5232820a0254dbde408ddf3.jpg";